import { LottoService } from './../../data/lotto.service';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { sprintf } from 'sprintf-js';
import { LoginDlgComponent } from 'src/app/dialog/login-dlg/login-dlg.component';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.scss']
})
export class AdminComponent implements OnInit {

  isSpin: boolean = false;
  lotName: string = '';
  viewDate: Date;
  matchId: number = 0;
  uid: number = 0;
  token: string = '';

  lotto1: string = '------';
  
  clTime1: number;
  clTime2: number;
  waitTime: number;
  spinTime: number;

  spinTimeStr: string = '';
  clTime1Str: string = '';
  clTime2Str: string = '';
  isLogin: boolean = false;
  passStr: string = '';

  constructor(private lotinfo: LottoService, public loginDialog: MatDialog) {
  }

  ngOnInit() {
    this.openDialog();
  }

  getMatch() {
    this.lotinfo.GetLottoMatch()
      .subscribe(data => {
        if (data.return) {
          this.matchId = data.dat.MATCH_ID;
          this.viewDate = data.dat.M_DATE;
          this.lotName = data.dat.LOTTO_NAME;
          let clt1 = new Date(data.dat.CLOSETIME_1);
          this.clTime1 = clt1.getTime();
          this.clTime1Str = sprintf('%02s:%02s', clt1.getHours(), clt1.getMinutes());
          let clt2 = new Date(data.dat.CLOSETIME_2);
          this.clTime2 = clt2.getTime();
          this.clTime2Str = sprintf('%02s:%02s', clt2.getHours(), clt2.getMinutes());
          let spin = new Date(data.dat.SPINTIME);
          this.spinTime = spin.getTime();
          this.spinTimeStr = sprintf('%02s:%02s', spin.getHours(), spin.getMinutes());
          this.waitTime = data.dat.WAITTIME * 1000; //convert to milli
          this.getLastResult();
        }
      });
  }

  getLastResult() {
    if (!this.matchId) return;
    this.lotinfo.GetLottoResultAdmin(this.matchId)
      .subscribe(data => {
        if (data.return) {
          this.lotto1 = data.dat.RESULT_1 ? data.dat.RESULT_1 : '------';          
        }
      });

  }

  getResult(vwdate) {
  }

  chkTimeDiff(chkt: String): boolean {   // hh:mm:ss
    let curt = new Date();
    let arrt = chkt.split(':');
    let rest = new Date();
    rest.setHours(parseInt(arrt[0]));
    rest.setMinutes(parseInt(arrt[1]) + 1); //delay showing 1 min
    rest.setSeconds(parseInt(arrt[2]));
    return curt.getTime() > rest.getTime();
  }

  numarr: string[] = [];
  chkDuplicate(chknum: string) {
    return this.numarr.find(st => st == chknum);
  }

  genNumber6(): string {
    for (let i = 0; i < 10; i++) {
      let x = sprintf('%06d', Math.floor(Math.random() * 1000000));
      if (!this.chkDuplicate(x)) {
        this.numarr.push(x);
        return (x);
      }
    }
    console.log('error');
  }
  genNumber4(): string {
    for (let i = 0; i < 10; i++) {
      let x = sprintf('%04d', Math.floor(Math.random() * 10000));
      if (!this.chkDuplicate(x)) {
        this.numarr.push(x);
        return (x);
      }
    }
    console.log('error');
  }
  genNumber3(): string {
    for (let i = 0; i < 10; i++) {
      let x = sprintf('%03d', Math.floor(Math.random() * 1000));
      if (!this.chkDuplicate(x)) {
        this.numarr.push(x);
        return (x);
      }
    }
    console.log('error');
  }
  genNumber2(): string {
    for (let i = 0; i < 10; i++) {
      let x = sprintf('%02d', Math.floor(Math.random() * 100));
      if (!this.chkDuplicate(x)) {
        this.numarr.push(x);
        return (x);
      }
    }
    console.log('error');
  }

  onRandom() {
    this.numarr = [];
    this.lotto1 = this.genNumber6();

  }

  onSave() {
    if (!/^\d{6}$/.test(this.lotto1 || '')) {
      alert('ผลรางวัลต้องเป็นตัวเลข 6 หลัก');
      return;
    }
    let lot = [];
    lot.push(this.lotto1);
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    lot.push('');
    this.lotinfo.SaveResult({ MATCH_ID: this.matchId, RES: lot, tk: this.token })
      .subscribe(data => {
        if (data.return) {
          alert('ข้อมูลถูกบันทึกแล้ว');
        }else{
          alert('การบันทึกขัดข้อง โปรดติดต่อผู้ดูแล...');
        }
      })
  }

  onSaveTime() {
    this.lotinfo.SaveTime({ matid: this.matchId, sptime: this.spinTimeStr, cltime2: this.clTime2Str, cltime1: this.clTime1Str, tk: this.token })
      .subscribe(data => {
        if (!data.return)
          alert('ไม่สามารถบันทึกข้อมูลได้');
        else
          alert('ข้อมูลถูกบันทึกแล้ว');
      })
  }

  onCheckLogin(usinfo: any) {
    this.lotinfo.Login(usinfo).subscribe(data => {
      if (data.return) {
        this.uid = data.dat.USER_ID;
        this.token = data.dat.TOKEN;
        this.isLogin = true;
        this.getMatch();
      } else {
        alert('รหัสไม่ถูกต้อง โปรดลองอีกครั้ง...');
      }
    })
  }

  openDialog(): void {
    const dialogRef = this.loginDialog.open(LoginDlgComponent, { hasBackdrop: true, panelClass: 'adm-login-dialog' });
    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.onCheckLogin(result);
    })
  }

  onSavePass(): void {
    this.lotinfo.SavePass(this.uid, this.passStr, this.token)
      .subscribe(data => {
        if (data.return) {
          alert('รหัสผ่านใหม่ ถูกบันทึกแล้ว.');
        }else{
          alert('การบันทึกขัดข้อง โปรดติดต่อผู้ดูแล...');
        }
      })
  }
}
